import { render } from "./ApplicationDetail.vue?vue&type=template&id=71b1564c&scoped=true"
import script from "./ApplicationDetail.vue?vue&type=script&lang=js"
export * from "./ApplicationDetail.vue?vue&type=script&lang=js"

import "./ApplicationDetail.vue?vue&type=style&index=0&id=71b1564c&scoped=true&lang=css"

import exportComponent from "D:\\VSCODE_POJECT\\back-to-class-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b1564c"]])

export default __exports__